import * as Yup from 'yup'
import { uniqBy } from 'lodash'
import { t } from 'translations'
import { UserEmail, UserPhoneNumber } from 'Api'

export const initYupCustomMethods = (): void => {
  Yup.addMethod<Yup.StringSchema>(Yup.string, 'importCode', function () {
    return this.test('importCode', t('administration.VALID_IMPORT_CODE'), value => /^(_|-|[0-9]|[A-z])+$/g.test(value as string))
  })

  Yup.addMethod<Yup.ArraySchema<Record<string, unknown>[]>>(Yup.array, 'uniqueRank', function (message: string) {
    return this.test('uniqueRank', message, list => {
      if (!list) return false
      return list.length === uniqBy(list, 'rank').length
    })
  })

  Yup.addMethod<Yup.ArraySchema<UserEmail>>(Yup.array, 'uniqueEmail', function (message: string) {
    return this.test('uniqueEmail', message, function (list) {
      if (!list) return false

      const mapper = (item: UserEmail) => item.address?.toLowerCase()
      const set = [...new Set(list.map(mapper))]
      const isUnique = list.length === set.length

      if (isUnique) return true

      const index = list.findIndex((l, i) => mapper(l) !== set[i])
      return this.createError({
        path: `emails[${index}].address`,
        message: message
      })
    })
  })

  Yup.addMethod<Yup.ArraySchema<UserPhoneNumber>>(Yup.array, 'uniquePhoneNumber', function (message: string) {
    return this.test('uniquePhoneNumber', message, function (list) {
      if (!list) return false

      const mapper = (item: UserPhoneNumber) => item.phoneNumber

      const set = [...new Set(list.map(mapper))]
      const isUnique = list.length === set.length

      if (isUnique) return true

      const index = list.findIndex((l, i) => mapper(l) !== set[i])
      return this.createError({
        path: `phoneNumbers[${index}].phoneNumber`,
        message: message
      })
    })
  })
}
